import api from '@/api'
import baseJs from '@/transformer/base'
import { getArrangedAchievement, getEmptyAchievementInfo } from '@/transformer/achievement'

const getDefaultState = () => {
  return {
    achievements: [],
    achievementTypes: [],
    fileRequiremants: {
      totalNum: 5,
      singleSize: 1024 * 1024 * 100, // アップロードできる1ファイルのサイズ
      totalSize: 0 // アップロードできるファイルサイズの和
    },
    achievement: getEmptyAchievementInfo(),
    timeList: [],
    listReaction: [],
    infoApiStatus: baseJs.getApiStatusEmpty(),
    listApiStatus: baseJs.getApiStatusEmpty(),
    listReactionApiStatus: baseJs.getApiStatusEmpty()
  }
}

const mutations = {
  setAchievements(state, achievements) {
    state.achievements = [...achievements]
  },
  setAchievementTypes(state, achievementTypes) {
    state.achievementTypes = [...achievementTypes]
  },
  setAchievement(state, achievement) {
    state.achievement = { ...achievement }
  },
  setListApiStatus(state, apiStatus) {
    state.listApiStatus = { ...apiStatus }
  },
  setInfoApiStatus(state, apiStatus) {
    state.infoApiStatus = { ...apiStatus }
  },
  setTimeList(state, timeList) {
    state.timeList = { ...timeList }
  },
  setTotalSize(state, totalSize) {
    state.fileRequiremants.totalSize = totalSize
  }
}

const actions = {
  async getAchievementList({ commit }) {
    await commit('setListApiStatus', baseJs.getApiStatusEmpty())
    try {
      const res = await api.achievement.list()
      await commit('setAchievements', res.list)
      await commit('setAchievementTypes', res.achievement_types)
      await commit('setListApiStatus', baseJs.getApiStatusSuccess())
      commit('setTotalSize', res.remained_space)
      return Promise.resolve()
    } catch (err) {
      const errorStatus = baseJs.getErrorStatus(err)
      await commit('setListApiStatus', { ...errorStatus })
      commit('setTotalSize', err.response.remained_space)
      return Promise.reject(err)
    }
  },
  async getAchievementInfo({ commit }, achievementId) {
    commit('setInfoApiStatus', baseJs.getApiStatusEmpty())
    try {
      const res = await api.achievement.info(Number(achievementId))
      commit('setAchievement', res.list[0])
      commit('setInfoApiStatus', baseJs.getApiStatusSuccess())
      commit('setTotalSize', res.remained_space)
      return Promise.resolve()
    } catch (err) {
      commit('setInfoApiStatus', { ...baseJs.getErrorStatus(err) })
      commit('setTotalSize', err.response.remained_space)
      return Promise.reject(err)
    }
  },
  async getProgramTimeAndCourse({ commit }) {
    try {
      const list = await api.announcement.listProgramTimeAndCourse()
      commit('setTimeList', list)
    } catch (err) {
      console.log(err) // TODO:
    }
  }
}

const getters = {
  /**
   * 最近の成果(最大5件)
   */
  achievementsForRecent(state) {
    const filteredAchievements = state.achievements.filter((achievement) => Number(achievement.is_draft) !== 1)

    filteredAchievements.sort((a, b) => {
      if (a.updated_at > b.updated_at) {
        return -1
      }
      return 1
    })

    return filteredAchievements.slice(0, 5)
  },
  selectedAchievement(state) {
    return getArrangedAchievement(state.achievement, state.achievementTypes, state.timeList.program_times)
  },
  achievementList(state) {
    return state.achievements.map((val) => {
      return getArrangedAchievement(val, state.achievementTypes)
    })
  },
  studentProfileUrls(state) {
    return state.listReaction.filter((data) => data.url_string)
  },
  listReactionDesc(state) {
    const sortedReactions = state.listReaction.slice()
    return sortedReactions.sort((a, b) => {
      if (a.updated_at > b.updated_at) {
        return -1
      }
      return 1
    })
  },
  achievementOptions(state) {
    return state.achievementTypes.map((type) => {
      return { text: type.name, value: Number(type.id) }
    })
  }
}

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations,
  actions,
  getters
}
